import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Row, Tooltip, Typography , Pagination, Form} from 'antd';
import {Field, reduxForm} from "redux-form";
import moment from "jalali-moment";

import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";
import DatePickerField from "../formFields/DatePickerField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'5%'
    },
    {
        title: 'کدسیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        width:"10%"
    },
    {
        title: 'نوع سند',
        dataIndex: 'document_type',
        width:"7%"
    },
    {
        title: 'مبلغ (ریال)',
        dataIndex: 'amount',
        width:"10%",
        className:"price",
        sorter: (a, b) => a.amount.localeCompare(b.amount)
    },
    {
        title: 'موجودی (ریال)',
        dataIndex: 'balance',
        width:"10%",
        sorter: (a, b) => a.balance.length - b.balance.length,
        className:"price"
    },
    {
        title: 'حساب بانک',
        dataIndex: 'bank_account',
        width:"13%",
    },
    {
        title: 'توضیحات کاربر',
        dataIndex: 'user_description',
        width:"20%"
    },
    {
        title: 'توضیحات سیستم',
        dataIndex: 'system_description',
    },
    {
        title: 'تاریخ ایجاد',
        dataIndex: 'date',
        width:"10%"
    },
];


class FinanceList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            filter:[]
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentWillMount() {
        this.props.getBankList()
        this.props.getList();
    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        const { Text } = Typography;
        var list = this.props.list;
        var dataSource = [];
        let priceType;
        if(list && list.lists) {

            for (let i = 0; i < list.lists.length; i++) {
                if(list.lists[i].document_type === "AD_WITHDRAW")
                    priceType = "danger"
                else
                    priceType = "success"

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    document_type: (list.lists[i].document_type === 'AD_DEPOSIT' ? 'واریز' : 'برداشت'),
                    amount : <Text type={priceType}>{(list.lists[i].amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</Text>,
                    balance: (list.lists[i].balance).toLocaleString(navigator.language, { minimumFractionDigits: 0 }),
                    bank_account: list.lists[i].bank_account.bank_title,
                    user_description : list.lists[i].user_description,
                    system_description: list.lists[i].system_description,
                    date: list.lists[i].created_at ? moment(list.lists[i].created_at).format('jYYYY/jM/jD HH:mm:ss') : ''
                });
            }
        }
        return dataSource;
    }

    __getBankList() {
        let bankList = this.props.bankList;
        let dataSource = [];

        if (bankList && bankList) {

            for (let i = 0; i < bankList.length; i++) {

                dataSource.push(
                    {label: bankList[i].title, value: bankList[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    async __onChangeCounter(current, pageSize) {
        this.setState({size:pageSize});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList();
        this.setState({current:1})
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {searchBoxHidden,pageSize } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">لیست اسناد حسابداری</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="plus" href="#/document/add">
                            ایجاد سند
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="document_type"
                                    component={SelectField}
                                    placeholder="نوع سند"
                                    list={[
                                        {label:'واریز',value:'AD_DEPOSIT'},
                                        {label:'برداشت',value:'AD_WITHDRAW'}
                                    ]}
                                    onChange={(document_type) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,document_type:document_type}
                                    }))}
                                />

                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="bank_account"
                                    component={SelectField}
                                    type="text"
                                    placeholder="حساب بانک"
                                    list={this.__getBankList()}
                                    onChange={(bank_account) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,bank_account:bank_account}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="ار تاریخ"
                                    timePicker={false}
                                    onChange={(created_from) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,created_from:created_from}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                    onChange={(created_to) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,created_to:created_to}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : 10)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions = {['10','20','50','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default FinanceList = reduxForm({
    form: 'list'
})(FinanceList)
